import React, { useState } from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Link,
  Typography,
  Stack,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

/* ICONOS */
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorIcon from "@mui/icons-material/Error";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ProfessionalCovenants from "src/Professional/ProfessionalCovenants";
import ProfessionalName from "src/Professional/ProfessionalName";
// import ProfessionalPhoto from "src/Professional/ProfessionalPhoto";
import ProfessionalSpecialities from "src/Professional/ProfessionalSpecialities";
import { cardBase, cardHeader } from "src/shared/styles/cardStyles";
import {
  capitalizeWord,
  serializeDateFormatLong,
} from "src/shared/global/helpers";
//import { useSetRecoilState } from "recoil";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import {
  listViewerExamsLabBase64FetchState,
  viewerExamsLabBase64State,
} from "src/Patient/state/atoms";
import {
  reservationForCancelSelectedState,
  showModalCancelReservationState,
} from "../state/atoms";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";

import Fab from "@mui/material/Fab";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ImageSearchOutlinedIcon from "@mui/icons-material/ImageSearchOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { userState } from "src/store/user/userState";

function createData(
  codigo,
  estadorechazo,
  estudio,
  prueba,
  resultado,
  fechaval,
  codigoEstado,
  estado,
) {
  return {
    codigo,
    estadorechazo,
    estudio,
    prueba,
    resultado,
    fechaval,
    codigoEstado,
    estado,
  };
}

function createData2(codigo, estadorechazo, estudio) {
  return {
    codigo,
    estadorechazo,
    estudio,
    pruebas: [],
  };
}

const ChildrenHeaderCard = ({ nroOrden, fecha }) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <Typography
        style={{
          fontWeight: 600,
          fontSize: 12,
        }}
      >
        {`N° Orden ${nroOrden}`}
      </Typography>

      <Typography
        style={{
          fontWeight: 600,
          fontSize: 12,
        }}
      >
        <CalendarTodayIcon
          style={{
            fontWeight: 600,
            fontSize: 12,
            marginRight: 10,
          }}
        />{" "}
        {fecha}
      </Typography>
    </div>
  );
};

const CardExamLab = ({ professional, cancelReservation = true }) => {
  const [loading, setLoading] = React.useState(false);
  const user = useRecoilValue(userState);
  const theme = useTheme();
  const isMediaScreen = useMediaQuery(theme.breakpoints.up("md"));

  const setShowModalCancelReservation = useSetRecoilState(
    showModalCancelReservationState,
  );
  const setReservationForCancelSelected = useSetRecoilState(
    reservationForCancelSelectedState,
  );

  const handleOpenModal = () => {
    setShowModalCancelReservation(true);
    setReservationForCancelSelected(professional);
  };

  const [viewerExamsLabBase64, setViewerExamsLabBase64] = useRecoilState(
    viewerExamsLabBase64State,
  );

  const handleOpenBase64 = useRecoilCallback(
    ({ snapshot }) =>
      async (numeroOrden, numeroExterno, objOrdenes) => {
        setLoading((prevLoading) => !prevLoading);

        let rut = user.payload.uswRut;
        rut = rut.trim();
        let dv = rut.substring(rut.length - 1, rut.length);
        let cadena = rut.substring(0, rut.length - 1);

        let rutdv = cadena + "-" + dv; //"18411451-8"; //

        if (numeroExterno == "") {
          numeroExterno = 0;
        }

        //Revisar tiene examenes validado
        let validado = 0;
        let noValidado = 0;
        objOrdenes.examenes.map(function (e) {
          e.pruebas.map(function (e) {
            validado = e.codigoEstado == 2 ? validado + 1 : validado + 0;
            noValidado = e.codigoEstado != 2 ? noValidado + 1 : noValidado + 0;
          });
        });

        // let ordenValida = "N";
        // if(noValidado > 0){
        //   ordenValida = "N";
        // }else{
        //   ordenValida = "S";
        // }

        //  PUERTO MONTT
        let ordenValida = "";
        if (process.env.REACT_APP_SEDE == "Puerto Montt") {
          if (objOrdenes.estadoCodigo == 1) {
            ordenValida = "S";
          } else {
            ordenValida = "N";
          }
        } else {
          if (noValidado > 0) {
            ordenValida = "N";
          } else {
            ordenValida = "S";
          }
        }

        let obj = {
          numeroOrden: numeroOrden,
          numeroExterno: numeroExterno,
          ordenValida: ordenValida,
          tipoDocumento: "rut",
          numeroDocumento: rutdv,
          sucursalOrigen: objOrdenes.sucursal,
        };

        const examsLabFetch = await snapshot.getPromise(
          listViewerExamsLabBase64FetchState(obj),
        );

        downloadPDF(examsLabFetch, numeroOrden);

        setLoading((prevLoading) => !prevLoading);
      },
    [],
  );

  const handleOpenBase642 = (numeroOrden, numeroExterno, obj) => {
    let validado = 0;
    let noValidado = 0;
    obj.examenes.map(function (e) {
      e.pruebas.map(function (e) {
        validado = e.codigoEstado == 2 ? validado + 1 : validado + 0;
        noValidado = e.codigoEstado != 2 ? noValidado + 1 : noValidado + 0;
      });
    });

    let ordenValida = "N";
    if (noValidado > 0) {
      ordenValida = "N";
    } else {
      ordenValida = "S";
    }
  };

  const downloadPDF1 = (pdf, numeroOrden) => {
    const linkSource = `${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = `${numeroOrden}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.setAttribute("target", "_blank");
    //downloadLink.click();
    setTimeout(function () {
      downloadLink.click();
      // Cleanup the DOM
      //document.body.removeChild(downloadLink);
    }, 500);
  };

  const downloadPDF = (base64PDF, numeroOrden) => {
    const binary = atob(base64PDF.split(",")[1]);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);

    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = `${numeroOrden}.pdf`;
    downloadLink.click();

    URL.revokeObjectURL(url);
  };

  const isPrivate = (obj) => {
    const allConfidential = obj.examenes.every(
      (e) => e.pruebas[0].estado === "Confidencial",
    );
    return allConfidential;
  };

  const handleTexto = (obj) => {
    let arregloTexto = "";
    if (obj != undefined) {
      arregloTexto = obj.map(function (element) {
        return `${element.nombre} - `;
      });
    }
    return arregloTexto;
  };

  const tableExamenes = (arreglo) => {
    /*
  0: Pendiente (Orden solo creada)
  1: Orden recepcionada por laboratorio
  2: Validada
  3: Rechazada
  */
    let rows = [];
    arreglo.map(function (element) {
      let codigo = element.codigo;
      let nombre = element.nombre;
      let pruebas = element.pruebas;
      let row = {};
      pruebas.map(function (e) {
        row = createData(
          codigo,
          "estadoRechazo",
          nombre,
          e.nombre,
          "resultado",
          e.fechaValidacion,
          e.codigoEstado,
          e.estado,
        );
      });

      rows.push(row);
    });

    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {/* <TableCell>Estado Rechazo</TableCell> */}
              <TableCell align="left">Estudio</TableCell>
              <TableCell align="left">Prueba</TableCell>
              <TableCell align="left">Resultado</TableCell>
              <TableCell align="left">Fecha Val</TableCell>
              <TableCell align="left">Estado</TableCell>
              <TableCell align="left"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.codigo}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left">{row.estudio}</TableCell>
                <TableCell align="left">{row.prueba}</TableCell>
                <TableCell align="left">{row.resultado}</TableCell>
                <TableCell align="left">{row.fechaval}</TableCell>
                <TableCell align="left">{row.estado}</TableCell>
                <TableCell align="right">
                  {row.codigoEstado == 2 && <CheckCircleIcon color="success" />}
                  {row.codigoEstado == 3 && <ErrorIcon color="error" />}
                  {row.codigoEstado == 1 && <PendingActionsIcon color="info" />}
                  {row.codigoEstado == 0 && <PendingIcon color="warning" />}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  //------

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <>
        {process.env.REACT_APP_SEDE == "Puerto Montt" ? (
          <React.Fragment>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
              <TableCell>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpen(!open)}
                >
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
              <TableCell component="th" scope="row">
                {row.nombre}
              </TableCell>
              <TableCell align="right">{}</TableCell>
              <TableCell align="right">{}</TableCell>
              <TableCell align="right">{}</TableCell>
              <TableCell align="right">{}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                style={{ paddingBottom: 0, paddingTop: 0 }}
                colSpan={6}
              >
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <Box sx={{ margin: 1 }}>
                    <Table size="small" aria-label="purchases">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Prueba</TableCell>
                          <TableCell align="left">Fecha Validación</TableCell>
                          <TableCell align="left">Estado</TableCell>
                          <TableCell align="left"></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.pruebas.map((historyRow) => (
                          <TableRow key={historyRow.nombre}>
                            <TableCell component="th" scope="row">
                              {historyRow.nombre}
                            </TableCell>
                            <TableCell>{historyRow.fechaValidacion}</TableCell>
                            <TableCell align="left">
                              {historyRow.estado === "Confidencial"
                                ? "Resultado Confidencial"
                                : historyRow.estado}
                            </TableCell>
                            <TableCell align="right">
                              {historyRow.codigoEstado == 1 && (
                                <CheckCircleIcon color="success" />
                              )}
                              {historyRow.estado == "Pendiente" && (
                                <PendingIcon color="warning" />
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
              <TableCell>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpen(!open)}
                >
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
              <TableCell component="th" scope="row">
                {row.nombre}
              </TableCell>
              <TableCell align="right">{}</TableCell>
              <TableCell align="right">{}</TableCell>
              <TableCell align="right">{}</TableCell>
              <TableCell align="right">{}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                style={{ paddingBottom: 0, paddingTop: 0 }}
                colSpan={6}
              >
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <Box sx={{ margin: 1 }}>
                    {/* <Typography variant="h6" gutterBottom component="div">
                    Detalle
                  </Typography> */}
                    <Table size="small" aria-label="purchases">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Prueba</TableCell>
                          <TableCell align="left">Fecha Validación</TableCell>
                          <TableCell align="left">Estado</TableCell>
                          <TableCell align="left"></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.pruebas.map((historyRow) => (
                          <TableRow key={historyRow.nombre}>
                            <TableCell component="th" scope="row">
                              {historyRow.nombre}
                            </TableCell>
                            <TableCell>{historyRow.fechaValidacion}</TableCell>
                            <TableCell align="left">
                              {historyRow.estado === "Confidencial"
                                ? "Resultado Confidencial"
                                : historyRow.estado}
                            </TableCell>
                            <TableCell align="right">
                              {historyRow.codigoEstado == 2 && (
                                <CheckCircleIcon color="success" />
                              )}
                              {historyRow.codigoEstado == 3 && (
                                <ErrorIcon color="error" />
                              )}
                              {historyRow.codigoEstado == 1 && (
                                <PendingActionsIcon color="info" />
                              )}
                              {historyRow.codigoEstado == 0 && (
                                <PendingIcon color="warning" />
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
        )}
      </>
    );
  }

  Row.propTypes = {
    row: PropTypes.shape({
      codigo: PropTypes.string.isRequired,
      nombre: PropTypes.string.isRequired,
      pruebas: PropTypes.arrayOf(
        PropTypes.shape({
          nombre: PropTypes.string.isRequired,
          codigoEstado: PropTypes.number.isRequired,
          estado: PropTypes.string.isRequired,
          fechaValidacion: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }).isRequired,
  };

  const tableCollapsibleExamenes = (arreglo) => {
    return (
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Estudio</TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right">&nbsp;</TableCell>
              <TableCell align="right">&nbsp;</TableCell>
              <TableCell align="right">&nbsp;</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {arreglo.map((row) => (
              <Row key={row.codigo} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  //------
  const [show, toggleShow] = React.useState(false);
  const handleShowHideTable = () => {
    toggleShow(!show);
  };

  return (
    <Card sx={{ ...cardBase }}>
      <CardHeader
        style={{ ...cardHeader }}
        title={
          <ChildrenHeaderCard
            fecha={professional?.fecha}
            nroOrden={professional?.numeroOrden}
          />
        }
      />
      <CardContent style={{ backgroundColor: "#F9FAFB" }}>
        <Grid
          style={{
            display: "flex",
            alignItems: !isMediaScreen ? "flex-start" : "center",
          }}
        >
          {/* <ProfessionalPhoto image={professional.imagen} alt={professional.ptdNombre} /> */}

          <Grid item md={12} ml={2}>
            <Grid item md={12}>
              {/* <ProfessionalName
                nameProfessional={ JSON.stringify(professional.examenes) }
              />
              <ProfessionalSpecialities specialities={professional.nombre} /> */}

              <ProfessionalName nameProfessional={"Exámenes"} />
              {/* <p>&nbsp;</p> */}
              <Typography
                paddingY={1}
                variant="subtitle2"
                style={{ fontWeight: "500", fontSize: 12 }}
              >
                {handleTexto(professional.examenes)}
              </Typography>

              {/* {tableExamenes(professional.examenes)} */}
              <Stack direction="row" spacing={1}>
                <Fab
                  variant="extended"
                  size="small"
                  color="primary"
                  aria-label="add"
                  onClick={() => {
                    handleShowHideTable();
                  }}
                  style={{ marginBottom: 10 }}
                >
                  {show == false ? (
                    <>
                      <VisibilityIcon sx={{ mr: 1 }} /> Ver Detalle
                    </>
                  ) : (
                    <>
                      <VisibilityOffIcon sx={{ mr: 1 }} /> Ocultar Detalle
                    </>
                  )}
                </Fab>
                <Fab
                  variant="extended"
                  size="small"
                  color="primary"
                  aria-label="estado"
                  disabled={false}
                  style={{ marginBottom: 10 }}
                >
                  {professional.estadoCodigo == 1 && (
                    <>
                      <CheckCircleIcon /> {professional.estado}{" "}
                    </>
                  )}
                  {professional.estadoCodigo == 0 && (
                    <>
                      <PendingIcon /> {professional.estado}{" "}
                    </>
                  )}
                </Fab>
              </Stack>

              {show && tableCollapsibleExamenes(professional.examenes)}
            </Grid>

            {/* <div>
              <p>{professional.estado} | {professional.estadoCodigo}</p>
              {professional.estadoCodigo == 1 && <CheckCircleIcon color="success" />}
              {professional.estadoCodigo == 0 && <PendingIcon color="warning" />}
            </div> */}

            <Grid container spacing={1} mt={2}>
              <Grid item xs={12} md={3}>
                <Typography
                  paddingY={1}
                  style={{ fontWeight: "bold", fontSize: 12 }}
                >
                  Resultados:
                </Typography>

                {loading ? (
                  <Box sx={{ display: "flex" }}>
                    <CircularProgress size={30} />
                  </Box>
                ) : (
                  <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    aria-label="add"
                    onClick={() => {
                      handleOpenBase64(
                        professional.numeroOrden,
                        professional.numeroExterno,
                        professional,
                      );
                    }}
                    disabled={isPrivate(professional)}
                    rel="noopener"
                  >
                    <DescriptionOutlinedIcon sx={{ mr: 1 }} />
                    DOCUMENTO
                  </Fab>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>

      {cancelReservation && (
        <CardActions style={{ padding: 16 }}>
          <Link
            style={{
              textDecoration: "none",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "18px",
            }}
            component="button"
            variant="body2"
            color="error"
            onClick={handleOpenModal}
          >
            Anular reserva
          </Link>
        </CardActions>
      )}
    </Card>
  );
};

export default CardExamLab;
